import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSalesPersonCode as applySalesPersonCode } from '../../actions/action';
import { setPageLoader } from '../../../../../Redux/order/createOrderSlice';
import { SuccessToast, ErrorToast } from '../../../../../utils/Toaster';

function AddSalesPersonInfo(props) {
  const { cart = {}, salesPersonCode = '' } = props || {};
  const dispatch = useDispatch();

  useEffect(() => {
    const applyCode = async () => {
      if (salesPersonCode) {
        dispatch(setPageLoader(true));
        await applySalesPersonCode({ salesmanCode: salesPersonCode }, dispatch);
        dispatch(setPageLoader(false));
      }
    };

    applyCode();
  }, [salesPersonCode, dispatch]);

  // Hide UI completely
  return null;
}

export default AddSalesPersonInfo;
